<template>
  <sfs-base-list-filter
    title="Filter GL Codes"
    :table-name="tableName"
    :applied-filters="appliedFilters"
    :displayed-columns="displayedColumns"
    :available-columns="translatedColumns(modelName, availableColumns)"
    @filters-applied="onFiltersApplied"
    @filters-reset="onDefaultPresetApplied"
    @filter-cleared="onFilterCleared"
    :advanced-filter="false"
    :popover-filter="true"
  >
    <template #quick-filters>
      <b-form-group
        label="Filter fields for Data"
        label-for="quick-filter-text"
        label-sr-only
      >
        <b-input-group>
          <b-form-input
            id="quick-filter-text"
            v-model="filters.text"
            type="text"
            placeholder="Filter by Name or Code"
            @keydown.enter.native="applyFilters"
          />
          <template #append>
            <b-button
              id="quick-filter-apply-button"
              @click="applyFilters"
              variant="primary"
            >
              <i class="fa fa-search" />
            </b-button>
          </template>
        </b-input-group>
      </b-form-group>
    </template>

    <template #popover-filters>
      <b-row>
        <b-col>
          <b-form-group
            label="Client"
            label-for="popover-filter-client_id"
            label-cols-lg="5"
            content-cols-lg="7"
          >
            <client-select
              id="popover-filter-client_id"
              placeholder="All"
              :value="client"
              @input="onClientChange"
              :persist-state="true"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group
            label="Category"
            label-for="popover-filter-category"
            label-cols-lg="5"
            content-cols-lg="7"
          >
            <category-select
              id="popover-filter-category"
              v-model="filters.category"
              placeholder="All"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group
            label="Status"
            label-for="popover-filter-active"
            label-cols-lg="5"
            content-cols-lg="7"
          >
            <b-form-radio-group
              id="popover-filter-active"
              v-model="filters.active"
              :options="activeOptions"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </template>
  </sfs-base-list-filter>
</template>
<script>
import ClientSelect from '@/components/admin/clients/Select.vue';
import CategorySelect from '@/components/admin/glCodes/CategorySelect.vue';
import { GL_CODE_TABLE_COLUMN_OPTIONS, GL_CODE_TABLE_DEFAULT_COLUMNS, GL_CODE_TABLE_NAME, GL_CODE_MODEL_NAME } from '@/constants/glCodes';
import translationMixin from '@/mixins/translationMixin';
import listFilterMixin from '@/mixins/listFilterMixin';

export default {
  name: 'GlCodesListFilter',
  mixins: [listFilterMixin, translationMixin],
  components: {
    ClientSelect,
    CategorySelect,
  },
  data() {
    return {
      availableColumns: GL_CODE_TABLE_COLUMN_OPTIONS,
      tableName: GL_CODE_TABLE_NAME,
      modelName: GL_CODE_MODEL_NAME,
    };
  },
  mounted() {
    this.loadInitialFilters();
  },
  methods: {
    onDefaultPresetApplied() {
      this.filters = {};
      this.displayedColumns = GL_CODE_TABLE_DEFAULT_COLUMNS;
      this.applyFilters();
    },
    onClientChange(client) {
      this.filters.client_id = client ? client.id.toString() : '';
      this.client = client;
    },
    loadInitialFilters() {
      const loadClient = new Promise((resolve) => {
        if (this.initialFilters.client_id) {
          this.$clientsAPI.get(this.initialFilters.client_id).then((client) => {
            resolve(client);
          });
        } else {
          resolve(null);
        }
      });

      // The order of the resolved promises is preserved so we are able to use
      // indexes to fetch the data.
      Promise.all([loadClient]).then((values) => {
        this.client = values[0];
        this.applyFilters();
      });
    },
  },
};
</script>
